import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Img } from "components";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";
import ProfileEdit from "../ProfileEdit";
import MyOccasions from "../AllTabsOption/MyOccasions";
import MyAddresses from "../AllTabsOption/MyAddresses";
import PaymentMathod from "../AllTabsOption/PaymentMathod";
import Preferredlanguage from "../AllTabsOption/Preferredlanguage";
import Wallet from "../AllTabsOption/Wallet";
import MyCustomCake from "../AllTabsOption/MyCustomCake";
import MyOrdersOrderlist from "../AllTabsOption/MyOrderList";
import { useMediaQuery } from "@mui/material";
import * as CUSTOM from "../../../utils/helper/custom";
import { getAuth } from "../../../redux/reducers/loginData";
import { useSelector } from "react-redux";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";

const MyOrder = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 990px)");
  const [activeTab, setActiveTab] = useState(0);
  const [bgColor, setBgColor] = useState("bg-gray-50_02");
  const location = useLocation();
  const { state } = location;
  const auth = useSelector(getAuth);

  const menuItems = [
    {
      section: "Account",
      items: [
        { id: 0, label: t("myOrders"), icon: "/images/bag.svg" },
        { id: 5, label: t("myCustomCakes"), icon: "/images/custCake.svg" },
        { id: 1, label: t("myOccasions"), icon: "/images/occasion.svg" },
        { id: 2, label: t("myAddresses"), icon: "/images/img_location.svg" },
      ]
    },
    {
      section: "Payments",
      items: [
        { id: 3, label: t("wallet"), icon: "/images/img_wallet.svg" },
        { id: 4, label: t("managePaymentMenthods"), icon: "/images/img_payment-menthod.svg" },
      ]
    },
    {
      section: "Settings",
      items: [
        { id: 6, label: t("preferredLanguage"), icon: "/images/lang.svg" },
      ]
    }
  ];

  useEffect(() => {
    let stepArray = [1, 2, 3, 4, 5, 6];
    const tabName = addDeleteGetLocalStorage(storageKeys.ORDER_TAB, {}, "get");
    if (tabName) {
      if (stepArray.includes(Number(tabName))) {
        addDeleteGetLocalStorage(storageKeys.ORDER_TAB, {}, "delete");
        setActiveTab(Number(tabName));
      } else {
        switch (tabName) {
          case "occasion":
            setActiveTab(1);
            break;
          case "mycustomcake":
            setActiveTab(5);
            break;
          default:
            setActiveTab(0);
            break;
        }
      }
    } else {
      if (state && state.tab) {
        setActiveTab(state.tab);
      } else {
        setActiveTab(0);
      }
    }
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams) {
      const orderType = urlSearchParams.get("order_type");
      const orderId = urlSearchParams.get("order_id");
      const paymentStatus = urlSearchParams.get("payment_status");
      const message = urlSearchParams.get("message");
      const amount = urlSearchParams.get("amount");
      if (orderType) {
        if (orderType == "wallet") {
          addDeleteGetLocalStorage(
            storageKeys.WALLET_RESPONSE,
            {
              order_type: orderType,
              transaction_id: orderId ? orderId : 0,
              payment_status: paymentStatus,
              amount: amount ? amount : 0,
              message: message ? message : "",
            },
            "add",
            "single"
          );
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
          setActiveTab(3);
        }
        if (orderType == "wallet" && paymentStatus == "success") {
          CUSTOM.sendWalletGaEvent(amount);
          CUSTOM.sendPaymentStatusGaEvent("success", "wallet", auth?.id, auth);
        }
        if (orderType == "wallet" && paymentStatus == "failed") {
          CUSTOM.sendPaymentStatusGaEvent("failed", "wallet", auth?.id, auth);
        }
      }
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const div = document.getElementById("order-box");
      if (div) {
        const rect = div.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;

        if (window.scrollY === 0) {
          // At the top of the page
          setBgColor("bg-gray-50_02");
        } else if (isVisible) {
          // Scrolling and div is visible
          setBgColor("bg-transparent");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [activeTab]);

  const handleLogout = () => {
    // Add logout functionality here
    console.log("Logout clicked");
  };

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return <MyOrdersOrderlist />;
      case 1:
        return <MyOccasions />;
      case 2:
        return <MyAddresses />;
      case 3:
        return <Wallet />;
      case 4:
        return <PaymentMathod />;
      case 5:
        return <MyCustomCake setValue={setActiveTab} />;
      case 6:
        return <Preferredlanguage />;
      default:
        return <MyOrdersOrderlist />;
    }
  };

  return (
    <>
      <div className="bg-[#FEFBFC] flex flex-col font-[Inter] items-center justify-start mx-auto w-full">
        <div className={`font-[Inter] relative w-full min-h-[100vh]`}>
          <ProfileEdit />
          <div
            id="order-box"
            className="flex flex-col items-center justify-center mx-auto w-full max-w-[1246px] py-[40px] md:py-5 px-[68px] md:px-5 bg-[#FEFBFC]"
          >
            {/*  Mobile Only - Horizontal Scrollable Tab Bar */}
            <div className="hidden sm:block w-full bg-[white] sticky top-[64px] z-20 border-b border-[#e5dcdc] mb-4">
              <div
                className="flex flex-row overflow-x-auto gap-0 scrollbar-hide"
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
              >
                {menuItems.flatMap((section) =>
                  section.items.map((item) => (
                    <button
                      key={item.id}
                      onClick={() => setActiveTab(item.id)}
                      className={`flex flex-row items-center justify-center gap-1 px-4 py-3 flex-shrink-0 transition-all duration-200 border-b-2 ${
                        activeTab === item.id
                          ? "border-[#771237] text-[#771237]"
                          : "border-[white] text-[#666]"
                      }`}
                    >
                      <Img
                        src={item.icon}
                        className={`w-5 h-5 ${
                          activeTab === item.id ? "opacity-100" : "opacity-50"
                        }`}
                        alt={item.label}
                      />
                      <span
                        className={`text-[12px] font-[Inter] font-medium whitespace-nowrap ${
                          activeTab === item.id ? "text-[#771237]" : "text-[#666]"
                        }`}
                      >
                        {item.label}
                      </span>
                    </button>
                  ))
                )}
              </div>
            </div>
            <div className="w-full bg-[#FEFBFC] relative flex flex-row sm:flex-col gap-0">
              {/* Left Sidebar Menu */}
              <div className="w-full max-w-[280px] sm:max-w-full bg-white-A700 border-r sm:hidden border-gray-200 sm:border-r-0 sm:border-b sticky top-[70px] h-fit sm:relative sm:top-0 overflow-y-auto" style={{border:"2px solid #e5dcdc", borderRadius:"10px"}}>
                {/* User Profile Section */}
                <div className="px-6 border-b border-gray-200">
                  <div className="flex items-center gap-3">
                    
                  </div>
                </div>

                {/* Menu Items */}
                <div className="py-4">
                  {menuItems.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="mb-6 last:mb-0">
                      {/* Section Header */}
                      <div className="px-6 mb-2">
                        <h4 className="text-[16px] font-semibold text-gray-400 uppercase tracking-wide font-[Inter]">
                          {section.section}
                        </h4>
                      </div>
                      
                      {/* Section Items */}
                      <div className="space-y-1">
                        {section.items.map((item) => (
                          <button
                            key={item.id}
                            onClick={() => setActiveTab(item.id)}
                            className={`w-full flex items-center gap-3 px-6 py-3 transition-all duration-200 ${
                              activeTab === item.id
                                ? "bg-pink-50 border-l-4 border-pink-600"
                                : "hover:bg-gray-50 border-l-4 border-transparent"
                            }`}
                          >
                            <Img
                              src={item.icon}
                              className={`w-5 h-5 ${
                                activeTab === item.id ? "opacity-100" : "opacity-60"
                              }`}
                              alt={item.label}
                            />
                            <span
                              className={`text-[14px] font-[Inter] font-medium ${
                                activeTab === item.id
                                  ? "text-pink-600"
                                  : "text-gray-700"
                              }`}
                            >
                              {item.label}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Content Area */}
              <div className="flex-1 bg-[#FEFBFC] pl-5 sm:p-2">
                {renderContent()}
              </div>
            </div>
          </div>
          <Footer className="absolute bottom-[0] flex font-nunitoregular inset-x-[0] items-center justify-center mx-auto w-full" />
        </div>
      </div>

      <style jsx>{`
        /* Custom scrollbar for sidebar */
        .overflow-y-auto::-webkit-scrollbar {
          width: 6px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 3px;
        }
        
        .overflow-y-auto::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }

        /* Mobile responsive styles */
        @media (max-width: 990px) {
          .max-w-[280px] {
            max-width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default MyOrder;
